export class User {
  id: number;
  email: string;
  firstname: string;
  lastname: string;

  constructor() {
    this.id = -1;
    this.email = "";
    this.firstname = "";
    this.lastname = "";
  }
}
